import { render, staticRenderFns } from "./addLanguages.vue?vue&type=template&id=3c2525ea&scoped=true&"
import script from "./addLanguages.vue?vue&type=script&lang=js&"
export * from "./addLanguages.vue?vue&type=script&lang=js&"
import style0 from "./addLanguages.vue?vue&type=style&index=0&id=3c2525ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2525ea",
  null
  
)

export default component.exports